module.exports = __webpack_public_path__ + "img/canvasMenuStart.a37df581.svg";